import { get } from 'lodash';
import { FC } from 'react';

export default <P,>(Wrapped: FC<P>) =>
  (propName: string, condition: (value: unknown) => boolean = Boolean) =>
  (props: P & JSX.IntrinsicAttributes) =>
    condition(get(props, propName)) ? <Wrapped {...props} /> : null;
